<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">

  		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Contact Group Detail" :menuAccess="true" :returnPreviousPage="true"></page-nav-bar>

  		<div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">

              <div class="panel-heading">
                  <h4 class="content-block labelAccordionForm">
                      <i class="fa fa-address-book formIcon"></i>
                      Contact Group Details
                  </h4>
              </div>

              <form>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label"><span class="color-red">* </span>Group name</label>
                  <div class="col-7 col-sm-10">
                    <input class="form-control" type="text" v-model="contactGroupLabel" disabled></input>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12"v-if="1">Contacts in this group</div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <ul class="list-group" v-if="1" disabled>
                      <li class="list-group-item" v-for="value in this.contactsArray" v-bind:key="value.id">{{ value.label }}</li>
                    </ul>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="row justify-content-start">
          <div class="offset-md-5 col-md-3 height-button">
            <button round class="button-action ">
                <a href="/account/editContactGroup/" style="color: #000;">
                  <i class="icon-edit icon icon-float-sub-button"></i>
                  <span>Edit contact group</span>
                </a>
            </button>
          </div>
          <div class="col-md-3 height-button">
            <button round class="button-action" @click="removeContactGroup">
              <i class="icon fa fa-times-circle" style="font-size: large;"></i>
              <span>Delete</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="toolbarPageBottomBlank"></div>
        </div>
      </div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      contactGroupId: '',
      contactGroupLabel: '',
      contactIdArray: [],
      contactsArray: []
    }
  },
  created () {
    this.contactGroupId = this.$settings.currentContactGroup.id
    this.contactGroupLabel = this.$settings.currentContactGroup.label
    this.contactIdArray = this.$settings.currentContactGroup.contacts
    for (let i = 0; i < this.$engine.contacts.get().length; i++) {
      if (this.contactIdArray.includes(this.$engine.contacts.get()[i].id)) {
        this.contactsArray.push(this.$engine.contacts.get()[i])
      }
    }
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    removeContactGroup () {
      let that = this
      that.$f7.confirm('Are you sure to delete this contact group?', 'Operation confirmation', function () {
        that.$engine.contacts
        .deleteContactGroup(that.contactGroupId)
        .then(resp => {
          that.$f7.modal({
            title: 'Contact group deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.contactGroupId = ''
            that.contactGroupLabel = ''
            that.contactIdArray = []
            that.contactsArray = []
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    }
  }
}
</script>

<style scoped>
@media (max-width:  768px) {
  .height-button {
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// CMContactGroupDetail.vue?64bb2bc2